import React, { useEffect, useState, Fragment } from 'react';
import { AlarmClockIcon } from 'lucide-react';
const day = 24 * 60 * 60 * 1000;
function getTarget() {
  const saved = localStorage.getItem('dance-fitness-countdown-target');
  const parsed = saved ? Number(saved) : 0;
  if (parsed > Date.now()) return parsed;
  const target = Date.now() + day;
  localStorage.setItem('dance-fitness-countdown-target', String(target));
  return target;
}
function format(ms: number) {
  const hours = Math.floor(ms / 3600000);
  const minutes = Math.floor(ms / 60000) % 60;
  const seconds = Math.floor(ms / 1000) % 60;
  return [hours, minutes, seconds].map(value => String(value).padStart(2, '0'));
}
export function CountdownTimer() {
  const [remaining, setRemaining] = useState(day);
  useEffect(() => {
    let target = getTarget();
    const update = () => {
      if (target <= Date.now()) {
        target = Date.now() + day;
        localStorage.setItem('dance-fitness-countdown-target', String(target));
      }
      setRemaining(target - Date.now());
    };
    update();
    const interval = window.setInterval(update, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const [hours, minutes, seconds] = format(remaining);
  return <section aria-label="Launch price countdown" className="mx-auto mt-10 max-w-3xl rounded-2xl border border-gold/35 bg-charcoal p-6 text-center" data-id="element-67">
      <p className="flex items-center justify-center gap-2 text-xs font-bold uppercase tracking-widest text-gold-light" data-id="element-68">
        <AlarmClockIcon size={18} data-id="element-69" /> The launch price ends in:
      </p>
      <div className="mt-5 flex justify-center gap-2 sm:gap-4" data-id="element-70">
        {[[hours, 'hours'], [minutes, 'min'], [seconds, 'sec']].map(([value, label], index) => <Fragment key={label} data-id="element-71">
            <div className="min-w-20 rounded-xl border border-gold/30 bg-charcoal-card px-3 py-3 sm:min-w-28" data-id="element-72">
              <strong className="block text-3xl tabular-nums text-white sm:text-4xl" data-id="element-73">
                {value}
              </strong>
              <span className="text-xs text-gold-light" data-id="element-74">{label}</span>
            </div>
            {index < 2 && <span className="self-center text-2xl font-bold text-gold-light" data-id="element-75">
                :
              </span>}
          </Fragment>)}
      </div>
      <p className="mt-5 text-xs font-bold uppercase tracking-wider text-zinc-300" data-id="element-76">
        After this, the price goes up — and it will not come back down.
      </p>
    </section>;
}